// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var meetingRoomIcon = PlaceOrderAssetsManager.getImage("meeting-room.svg");

function AddressCardCmp(Props) {
  var address = Props.address;
  var match = address.address2.length;
  return React.createElement("div", {
              className: "address-card__container"
            }, React.createElement("div", undefined, address.address1), React.createElement("div", {
                  className: "building-address"
                }, React.createElement("img", {
                      alt: "building-icon",
                      src: meetingRoomIcon
                    }), React.createElement("span", undefined, match !== 0 ? address.address2 : "-")), React.createElement("div", {
                  className: "user-details__container"
                }, React.createElement("span", {
                      className: "name"
                    }, address.senderName), React.createElement("span", undefined, "·"), React.createElement("span", undefined, address.senderNumber)));
}

var make = AddressCardCmp;

export {
  meetingRoomIcon ,
  make ,
  
}
/* meetingRoomIcon Not a pure module */
